<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icon/Dropdown">
      <g id="Group 181">
        <path id="Vector 15" d="M20 12L14.5 18L9 12" stroke="#18246F" stroke-width="1.5" />
      </g>
    </g>
  </svg>
</template>
